import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const servicesRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = servicesRef.current?.querySelectorAll('.service-card');
    cards?.forEach((card) => {
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M24 4L6 14V24C6 32.5 10.5 40.5 18 44.5L24 47.5L30 44.5C37.5 40.5 42 32.5 42 24V14L24 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M24 18V28M24 18L18 22M24 18L30 22M24 28L18 32M24 28L30 32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Sales',
      description: 'Explore our premium range of Hyundai vehicles with expert guidance and competitive pricing.',
      link: 'tel:+917575808003',
      linkText: 'Contact Sales'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M8 24H40M8 24L16 16M8 24L16 32M40 24L32 16M40 24L32 32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2"/>
        </svg>
      ),
      title: 'Service',
      description: 'Authorized service center with certified technicians and genuine parts for optimal performance.',
      link: 'tel:+917575808004',
      linkText: 'Book Service'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <rect x="8" y="12" width="32" height="24" rx="2" stroke="currentColor" strokeWidth="2"/>
          <path d="M8 20H40M20 12V8C20 6.89543 20.8954 6 22 6H26C27.1046 6 28 6.89543 28 8V12" stroke="currentColor" strokeWidth="2"/>
          <circle cx="18" cy="28" r="2" fill="currentColor"/>
          <circle cx="30" cy="28" r="2" fill="currentColor"/>
        </svg>
      ),
      title: 'Genuine Spares',
      description: '100% authentic Hyundai spare parts ensuring quality, reliability, and warranty protection.',
      link: '/contact',
      linkText: 'Inquire Now'
    }
  ];

  return (
    <section className="services" id="services" ref={servicesRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">Comprehensive automotive solutions under one roof</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card" style={{ transitionDelay: `${index * 100}ms` }}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              {service.link.startsWith('tel:') ? (
                <a href={service.link} className="service-link">
                  <span>{service.linkText}</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              ) : (
                <Link to={service.link} className="service-link">
                  <span>{service.linkText}</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;

